import {
  ARTIFACTS_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SEARCH_VERSION_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from 'src/components/packages/constants';
import repoUrls from 'src/sections/repository/urls';

import {
  NpmVersionsResponse,
  NugetVersionsResponse,
  PackageType,
} from '../types';
import { buildPackagesApiQueryString } from '../utils';

import { packagesResourceFactory } from './utils';

const packagesVersionsResourceFactory = <ResponseType>(
  packageType: PackageType
) =>
  packagesResourceFactory<ResponseType>()({
    key: `packages-${packageType}-versions`,
    pathParamNames: ['packageName'] as const,
    queryParamNames: [
      PAGE_QUERY_PARAM,
      SORT_QUERY_PARAM,
      SEARCH_VERSION_QUERY_PARAM,
    ] as const,
    getRequestUrl: (context, pathParams, queryParams) => {
      const queryString = buildPackagesApiQueryString({
        ...queryParams,
        packageName: pathParams.packageName,
        [PAGELEN_QUERY_PARAM]: ARTIFACTS_PAGE_LENGTH.toString(),
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.packageRegistryVersions(
            context.workspaceSlug,
            context.repositorySlug,
            packageType,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });

export const packagesNpmVersionsResource =
  packagesVersionsResourceFactory<NpmVersionsResponse>('npm');

export const packagesNugetVersionsResource =
  packagesVersionsResourceFactory<NugetVersionsResponse>('nuget');
